<template>
  <div class="my-confirm-plaugin-box" v-show="dialogVisible">
    <div class="confirm-plaugin-box">
      <div class="confirm-title">
        <div>{{title}}</div>
        <div @click="submit(false)"><img src="@/assets/img/confirmPlaugin/close.png" alt=""></div>
      </div>
      <div class="comfirm-content">
        <div class="tc-30"></div>
        <slot></slot>
        <div class="tc-40"></div>
        <div class="comfirm-btn">
          <Button3 v-if="buttonClose != ''" @click="submit(false)">{{buttonClose}}</Button3>
          <Button1 @click="submit(true)" v-if="!showButton">{{buttonSubmit}}</Button1>
          <Button2 v-if="showButton">{{buttonSubmit}}</Button2>
        </div>
        <div class="tc-40"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ConfirmPlaugin3',
  props: {
    buttonSubmit: {
      type: String,
      default: '确认'
    },
    buttonClose: {
      type: String,
      default: '取消'
    },
    title: {
      type: String,
      default: '温馨提示'
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      type: 'error',
      // buttonSubmit: '确认',
      // buttonClose: '取消',
      // title: '温馨提示',
      dialogVisible: false
    }
  },
  methods: {
    open () {
      this.dialogVisible = true
    },

    submit (bol) {
      if (bol) {
        this.$emit('submit')
        // this.submit()
      } else {
        this.$emit('reset')
      }
      // this.dialogVisible = false
      // this.reset()
    },
    close () {
      this.dialogVisible = false
    }
  },
  mounted () {},
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//
  .my-confirm-plaugin-box{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
    .confirm-plaugin-box{
      width: 600px;
      margin: 10% auto;
      height: auto;
      /*min-height: 300px;*/
      background-color: #ffffff;
      border-radius: 4px;
      border:1px solid rgba(228, 231, 237, 1);
      box-shadow:0 3px 10px 0 rgba(0, 0, 0, 0.08);
      .confirm-title{
        font-size: 18px;
        border-bottom: 1px solid #E4E7ED;
        height: 60px;
        line-height: 60px;
        // padding: 0 20px 0 15px;
        position: relative;
        >div{
          position: absolute;
          &:nth-child(1){
            left: 0;
            text-indent: 15px;
            top: 0;
          }
          &:nth-child(2){
            right: 0;
            top: 0;
            padding: 0 15px;
            cursor: pointer;
          }
        }
      }
      .comfirm-content{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        padding: 0px 0 0px 0;
        img{
          display: block;
          margin: 0 auto 20px;
        }
        span{
          color: #969696;
          font-size: 16px;
        }
        .comfirm-btn{
          >button{
            &:nth-child(2){
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
</style>
